import { MerchantAndStore } from './type';

export const CLIENT_MIN_TIERS = [10, 50, 100, 250, 500, 1000];
export const PASSAGE_MIN_TIERS = [10, 50, 100, 250, 500, 1000];
export const POINTS_MIN_TIERS = [100, 500, 1000, 5000, 10000];
export const MARKETING_INACTIVITY_PERIODS = [7, 30, 90] as const;
export const NEVER_SENT = 'never';
export const URL_DATE_FORMAT = 'YYYY-MM-DD';

export type MarketingInactivity = (typeof MARKETING_INACTIVITY_PERIODS)[number] | typeof NEVER_SENT;

export type MerchantListFilters = {
  createdFrom?: string;
  createdTo?: string;
  minClients?: number;
  minPassages30d?: number;
  minPointsEarned30d?: number;
  lastSms?: MarketingInactivity;
  lastPush?: MarketingInactivity;
  categoryId?: string;
};

export const MERCHANT_LIST_URL_KEYS = [
  'createdFrom',
  'createdTo',
  'minClients',
  'minPassages',
  'minPoints',
  'lastSms',
  'lastPush',
  'category',
] as const;

export type MerchantListUrlKey = (typeof MERCHANT_LIST_URL_KEYS)[number];

export type MerchantListPage = {
  data: MerchantAndStore[];
  metadata: { total: number; page: number; size: number };
};
